import { IconNames, Text } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';

import {
  FlowNode,
  flowNodeColor,
  NodeT,
  NodeTypeComponent,
} from 'fable/flowEditor';
import { AutomationNodeTypes } from 'hocs';

import { QueueModal } from '../modals/queue';
import type { AutomationFlowExtraDataT } from '../types';

export type AutomationNodeQueuePayloadT = {
  transferToQueueId: null | string;
  queueName: null | string;
};
export type AutomationNodeQueueTypeT = AutomationNodeTypes.QUEUE;
export type AutomationNodeQueueT = NodeT<
  AutomationNodeQueueTypeT,
  AutomationNodeQueuePayloadT
>;

export class QueueNode extends NodeTypeComponent<
  AutomationNodeQueueT,
  AutomationFlowExtraDataT
>() {
  static icon: IconNames = 'users';
  static label = 'Queue';
  static color = flowNodeColor.green;
  static ActionModal = QueueModal;
  static actionTrigger = { type: AutomationNodeTypes.QUEUE };
  static updateConnection = (
    node: AutomationNodeQueueT,
  ): AutomationNodeQueueT => node;

  @boundMethod
  triggerEdit(): void {
    const { onEdit, node } = this.props;
    onEdit(node, node.nodeType);
  }

  render() {
    const {
      node: {
        payload: { queueName },
      },
    } = this.props;

    return (
      <FlowNode
        color={QueueNode.color}
        icon={QueueNode.icon}
        label={QueueNode.label}
        text={
          <Text.Paragraph clamp={1} variant="1">
            {queueName ?? 'Re-offer'}
          </Text.Paragraph>
        }
        onEdit={this.triggerEdit}
      />
    );
  }
}
